function isMobile() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (/windows phone/i.test(userAgent) ||
    /android/i.test(userAgent) ||
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ||
    ($(window).width() <= 1024 && $(window).height() <= 1366));
}

export default isMobile();
